// This file contain all hard code data which fetch the data from swiggy website

export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL =
  "https://graphicdesigneye.com/images/rastaurant-logo-design-service.png";
